'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var tabTriggers = (0, _functional.getElements)('.' + context.className + '_Trigger');
  var tabPanels = (0, _functional.getElements)('.' + context.className + '_Panel');

  tabTriggers.forEach(function (tabTrigger) {
    tabTrigger.addEventListener('click', function () {
      var activePanelName = tabTrigger.dataset.productTab;

      tabTriggers.forEach(function (tempTabTrigger) {
        var currentTabName = tempTabTrigger.dataset.productTab;
        tempTabTrigger.setAttribute('aria-current', currentTabName === activePanelName);
      });

      tabPanels.forEach(function (tabPanel) {
        var currentPanelName = tabPanel.dataset.productPanel;
        tabPanel.setAttribute('aria-current', currentPanelName === activePanelName);
      });
    });
  });
}